import HttpCodes from 'http-status-codes';
import React from 'react';
import classNames from 'classnames';
import { BLANK_IMAGE } from '@/hybrid/annotation/ckEditorPlugins/components/RefreshingContent.molecule';
import { ContentVisualizationProps } from '@/hybrid/annotation/ckEditorPlugins/components/content.utilities';
import { getAxiosInstance } from '@/hybrid/requests/axios.utilities';
import { CONTENT_LOADING_CLASS, IMAGE_BORDER_CLASS } from '@/reportEditor/report.constants';

export const ImageContent: React.FunctionComponent<ContentVisualizationProps> = ({
  contentId,
  noMargin,
  border,
  errorClass,
  style,
  loading,
  target,
  src,
  onLoad,
  onError,
  onMeasurementsReady,
  showMenu,
  error,
}) => {
  return (
    <img
      data-testid={`content-${contentId}`}
      data-seeq-content={contentId}
      data-visualization="image"
      style={style}
      ref={target}
      className={classNames(noMargin ? '' : 'p2', border ? IMAGE_BORDER_CLASS : '', errorClass ?? '', {
        [CONTENT_LOADING_CLASS.SPINNER]: loading && !errorClass,
        [CONTENT_LOADING_CLASS.LOADED]: !loading && !errorClass,
      })}
      title={error}
      src={errorClass ? BLANK_IMAGE : src}
      onLoad={(ref) => {
        // Initial load will return a 1x1 empty image. Subsequent loads shouldn't.
        if (ref.currentTarget.naturalWidth !== 1 && ref.currentTarget.naturalHeight !== 1) {
          onLoad();
          // if it's an image let it take it's own size
          onMeasurementsReady(0, 0);
        }
      }}
      onError={(e) => {
        const image = e.currentTarget;
        // re-try the request and get the error message to show more information in a tooltip
        getAxiosInstance()
          .get(e.currentTarget.src)
          .catch((error) => {
            if (error.status === HttpCodes.FORBIDDEN) {
              image.title = error.data.statusMessage;
              onError(error.data.statusMessage, error.status);
            }
          });
        image.className = 'contentLoadError';
        image.src = BLANK_IMAGE;
      }}
      onClick={showMenu}
    />
  );
};
